/**
 * Captcha Demo Page - For testing the captcha component
 */

import { useState } from "react";
import { Captcha } from "../components/Captcha";
import { Card } from "@bcc/shared-ui";

export function CaptchaDemo() {
  const [verifiedToken, setVerifiedToken] = useState<string | null>(null);
  const [showCaptcha, setShowCaptcha] = useState(true);

  return (
    <div className="max-w-2xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-4">Captcha Demo</h1>
      <p className="text-gray-600 mb-6">
        This page demonstrates the custom captcha component used for bot
        protection.
      </p>

      {verifiedToken ? (
        <Card className="p-6 bg-green-50 border-green-200">
          <h2 className="text-lg font-semibold text-green-700 mb-2">
            ✅ Verification Successful!
          </h2>
          <p className="text-sm text-gray-600">
            You can now continue using the application.
          </p>
          <button
            onClick={() => {
              setVerifiedToken(null);
              setShowCaptcha(true);
            }}
            className="mt-4 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
          >
            Try Again
          </button>
        </Card>
      ) : showCaptcha ? (
        <Captcha
          onVerify={(token) => {
            setVerifiedToken(token);
            setShowCaptcha(false);
          }}
          onError={(err) => {
            console.error("Captcha error:", err);
          }}
        />
      ) : null}

      <div className="mt-8 p-4 bg-gray-50 rounded-lg">
        <h3 className="font-semibold mb-2">How it works:</h3>
        <ol className="list-decimal list-inside space-y-2 text-sm text-gray-600">
          <li>Backend generates a math challenge (e.g., "15 + 23 = ?")</li>
          <li>An image with visual noise is created to prevent OCR</li>
          <li>User solves the problem and submits the answer</li>
          <li>Backend verifies and returns a token valid for 30 minutes</li>
          <li>Token is included in subsequent API requests</li>
        </ol>
      </div>
    </div>
  );
}

export default CaptchaDemo;
